import ResponseEntity, { DtoConversionError, RequestEntity } from "../index";

export default class OutputLinktreeEntry extends ResponseEntity {
  constructor(
    public readonly id: string,
    public readonly ref: string,
    public readonly name: string,
    public readonly local: boolean
  ) {
    super(id);
  }

  static convert(input: any): OutputLinktreeEntry {
    if (input instanceof OutputLinktreeEntry) return input;

    const id = input.id ?? undefined;
    const ref = input.ref ?? undefined;
    const name = input.name ?? undefined;
    const local = input.local ?? undefined;

    if (typeof id !== "string")
      throw new OutputLinktreeEntryConversionError("id", input);
    if (typeof ref !== "string")
      throw new OutputLinktreeEntryConversionError("ref", input);
    if (typeof name !== "string")
      throw new OutputLinktreeEntryConversionError("name", input);
    if (typeof local !== "boolean")
      throw new OutputLinktreeEntryConversionError("local", input);

    return OutputLinktreeEntryConversionError.propagate(
      OutputLinktreeEntryConversionError.dtoName,
      () => new OutputLinktreeEntry(id, ref, name, local)
    );
  }
}

class OutputLinktreeEntryConversionError extends DtoConversionError {
  public static dtoName: string = "OutputLinktreeEntry";
  constructor(propertyName: string, rawData: any, hint?: string) {
    super(
      OutputLinktreeEntryConversionError.dtoName,
      propertyName,
      rawData,
      hint
    );
  }
}

export class RequestLinktreeEntriesList extends RequestEntity {
  public readonly list = null;

  constructor(public readonly count?: number) {
    super();
  }
}

export class RequestLinktreeEntryById extends RequestEntity {
  constructor(public readonly entry: string) {
    super();
  }
}
